import React from "react";
import * as Icons from "lucide-react";
import { fmtDate, tzLabel } from "../lib/helpers";

// Carte de RDV en lecture (visio ou physique) affichée dans les portails client/collab/admin.
export const RdvCard = ({ rdv = {}, testId = "phase" }) => {
  if (!rdv.rdv_type) return null;
  const isVisio = rdv.rdv_type === "visio";
  const mapsUrl = rdv.rdv_address ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(rdv.rdv_address)}` : null;
  return (
    <div data-testid={`phase-rdv-${testId}`} className="mt-3 rounded-sm border border-marine/15 bg-marine/[0.03] p-3.5 flex items-center justify-between flex-wrap gap-3">
      <div className="min-w-0">
        <div className="text-xs uppercase tracking-wider text-marine/80 flex items-center gap-1.5">
          {isVisio ? <Icons.Video size={16} className="text-marine" /> : <Icons.MapPin size={16} className="text-marine" />}
          {isVisio ? "RDV visio · validation vidéo" : "RDV physique · sur place"}
        </div>
        <div className="text-sm text-marine font-medium mt-0.5">
          {rdv.rdv_date ? fmtDate(rdv.rdv_date) : "Date à confirmer"}
          {rdv.rdv_time && <span> · {rdv.rdv_time}</span>}
          {rdv.rdv_timezone && <span className="text-marine/80 font-normal"> ({tzLabel(rdv.rdv_timezone)})</span>}
        </div>
        {!isVisio && rdv.rdv_address && <div className="text-xs text-marine/80 mt-1 truncate">{rdv.rdv_address}</div>}
      </div>
      {isVisio && rdv.rdv_link && (
        <a href={rdv.rdv_link} target="_blank" rel="noopener noreferrer" data-testid={`phase-rdv-join-${testId}`}
          className="bg-marine text-white rounded-sm px-4 py-2 text-sm hover:bg-marine-hover active:scale-95 transition-all flex items-center gap-1.5 shrink-0">
          <Icons.Video size={16} /> Rejoindre la visio
        </a>
      )}
      {!isVisio && mapsUrl && (
        <a href={mapsUrl} target="_blank" rel="noopener noreferrer" data-testid={`phase-rdv-map-${testId}`}
          className="border border-marine/30 text-marine rounded-sm px-4 py-2 text-sm hover:bg-marine hover:text-white transition-colors flex items-center gap-1.5 shrink-0">
          <Icons.MapPin size={16} /> Voir sur la carte
        </a>
      )}
    </div>
  );
};

export default RdvCard;
